export enum LeadEventTypeEnum {
  LEAD_UPDATED = "Lead Updated",
  LEAD_WORKFLOW_STATUS_UPDATED = "Lead Workflow Status Updated",
  LEAD_CREATED = "Lead Created",
}
